import React from 'react';
import {connect} from 'react-redux';
import {plainTranslate} from "../../common/translate";
import client from '../../../actions/client';
import showAToast from '../../common/showAToast';

class LineButton extends React.Component {

    constructor(props) {
        super(props);
        this.clickButton = this.clickButton.bind(this);
    }
    
    clickButton() {
//        console.log(this.props.field.linkUrl);  линк към където трябва да отиде потребителя след действието
//        console.log(this.props.field.actionUrl); линк на действието
//        console.log(this.props.formData.ids); ид нужно за действията
        let addVal = {};
        let jsonData = [];
        if (this.props.field.hasOwnProperty('lineDependency')) {
                this.props.field.lineDependency.map(field => {
                    let numb = (this.props.name).match(/^(\D*)(\d+)/)[2];
                    addVal[field] = this.props.formData.lines[numb][field];
                })
            } 
        if (this.props.field.hasOwnProperty('dependency')) {
            this.props.field.dependency.map(field => {
               // console.log(field);
                addVal[field] = this.props.formData[field];
            })
        } 
      //  console.log(addVal);
        jsonData.push(JSON.stringify(addVal));
        client.post(this.props.field.actionUrl, addVal)
                        .then(response => response.data)
                        .then(response => {
                           if (response['success']) {
                                showAToast(plainTranslate(this.props.settings.locale, response.success), 'succSettings', 'success');
                                this.props.history.push(this.props.field.linkUrl);
                           } else {
                                showAToast(plainTranslate(this.props.settings.locale, response.errors), 'errSettings', 'error');
                           }
                })
        
    }

    render() {//console.log(this.props)
        return <React.Fragment>
                <button type="button" name={this.props.field.id} onClick={this.clickButton}>{plainTranslate(this.props.locale, this.props.field.buttonText)}</button>
             </React.Fragment>
    }
}
    
const mapStateToProps = state => ({
   // formData: state,
});

const mapDispatchToProps = dispatch => ({

    });

export default connect(mapStateToProps, mapDispatchToProps)(LineButton);

